import { IsArray, IsString } from 'class-validator';

export class AdminTriggerWorkspaceRefreshPlansDto {
  @IsArray()
  @IsString({ each: true })
  workspaceNames: string[];
}
